<template>
  <div class="centered-box locations-white locations-generic">
    <div class="twilight">
      <div class="locations-title">Twilight Nature Paddle</div>
      <br />
      Early-evening, guided nature trips are available from our Clark Park boathouse. Whether you’re an experienced paddler or complete beginner, join us and we’ll show you why these guided trips have become a customer favorite.
      <br /><br />
      Twilight Nature Paddle events include an on-shore, pre-trip safety talk. Basic paddling instruction will be available for anybody who needs it. Children welcome (minimum age 8 years; must be accompanied by an adult).
      <br /><br />
      Price: Single kayak—$35*; Tandem kayak or canoe—$50*
      <br />
      <small>*Plus 15% Chicago Entertainment Tax</small>
      <br />
      <br />
      <!-- Please make your reservation below.<br><br>  -->
    </div>
  </div>
</template>

      <!-- <br />We’re confident that you’ll be surprised and delighted to see how vibrant and diverse the wildlife is on the Chicago River. While what you’re likely to see will depend on weather conditions and the time of the season, previous participants have reported sightings of, among other things, bald eagles, herons, cormorants, egrets, kingfishers, turtles, coyotes, beaver, and mink.
      <br />
      <br />Although our guides do not claim to be expert naturalists, they do know their stuff and will work hard to make your outing informative and fun.
      <br />
      <br />Twilight Nature Paddle events include an on-shore, pre-trip safety talk. Basic paddling instruction will be available for anybody who needs it. Children welcome (minimum age 8 years; must be accompanied by an adult).
      <br />
      <br />
      <h5>Event duration:</h5>90 minutes
      <br />
      <br />
      <h5>Price:</h5>Single kayak—$50*; Tandem kayak or canoe—$70* -->
      

<script>
export default {
  name: "Twilight",
  props: {
    msg: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.twilight {
  color: black;
  margin-left: 20px;
  margin-right: 20px;
}
</style>
